var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"page",class:{ 
        'with-header' : _vm.type != 'no-header', 
        'no-helpers' : _vm.type == 'no-helpers', 
    }},[_c('div',{staticClass:"main"},[_vm._t("default")],2),(!!_vm.$slots.bottom)?_c('div',{staticClass:"helpers"},[_vm._t("bottom")],2):_vm._e()])}
var staticRenderFns = []

export { render, staticRenderFns }